module.exports = __webpack_public_path__ + "img/empty_order_list.dd87557e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/empty_order_list.png
// module id = Fa3T
// module chunks = 1